import * as TYPES from './types'
import * as LESSON_TYPES from '@/store/modules/lesson/types'
import * as TASTING_TYPE from '@/store/modules/tasting/types'
import { normalizeThemes } from '@/services/normalizer'

import { functions } from '@/services/firebase'

export default {
  [TYPES.LOAD_THEMES]({ dispatch, commit }, { locale, callback = function() {} }) {
    const loadThemes = functions.httpsCallable('loadThemes')
    loadThemes({ locale }).then(response => {
      commit(TYPES.SET_THEMES, response.data)
      dispatch(TYPES.SYNC_THEMES, response.data)
      callback(null, true)
    })
  },
  [TYPES.SYNC_THEMES]: async ({ commit }, themePayload) => {
    const normalizedThemes = normalizeThemes(themePayload)

    const lessonStepById = normalizedThemes.entities.lessonStep || {}
    const lessonStepAllIds = Object.keys(lessonStepById)

    commit(LESSON_TYPES.SET_LESSON_STEPS, { allIds: lessonStepAllIds, byId: lessonStepById })

    const lessonById = normalizedThemes.entities.lesson || {}
    const lessonAllIds = Object.keys(lessonById)

    commit(LESSON_TYPES.SET_LESSONS, { allIds: lessonAllIds, byId: lessonById })

    const tastingById = normalizedThemes.entities.tasting || {}
    const tastingAllIds = Object.keys(tastingById)

    commit(TASTING_TYPE.SET_TASTINGS, { allIds: tastingAllIds, byId: tastingById })

    const tastingQuestionById = normalizedThemes.entities.tastingQuestion || {}
    const tastingQuestionAllIds = Object.keys(tastingQuestionById)

    commit(TASTING_TYPE.SET_TASTING_QUESTIONS, {
      allIds: tastingQuestionAllIds,
      byId: tastingQuestionById
    })

    const tastingTransitionById = normalizedThemes.entities.tastingTransition || {}
    const tastingTransitionAllIds = Object.keys(tastingTransitionById)

    commit(TASTING_TYPE.SET_TASTING_TRANSITIONS, {
      allIds: tastingTransitionAllIds,
      byId: tastingTransitionById
    })
  }
}
